export default __webpack_public_path__ + "0e58fea09cafc47b7c3e26812937d583.svg";